"use client";

import { APP, decode, isAdmin, MODALS } from "@idss/libraries";
import { handleError } from "@idss/notification";
import { Button, Flex, Stack, Text, Title } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useMutation } from "@tanstack/react-query";
import { useCookies } from "next-client-cookies";

import { builder } from "@/builders";
import { SecurityIcon } from "@/svgs/security-icon";

import { TwoFactorAuthentication } from "./two-factor-authentication";

export function EnableTwoFactorAuthentication() {
  const cookies = useCookies();

  const email = cookies.get(APP.EMAIL) ?? "";
  const userType = decode<string>(cookies.get(APP.USER_TYPE)) ?? "";
  const admin = isAdmin(userType);

  const { mutate, isPending } = useMutation({
    mutationFn: builder.$use.two_fa.generate,
    onError: handleError(),
    onSuccess: ({ data }) => {
      modals.open({
        modalId: MODALS.TWO_FACTOR_AUTHENTICATION,
        children: <TwoFactorAuthentication email={email} {...data} />,
        withCloseButton: false,
      });
    },
  });

  function handleEnable() {
    mutate({ email });
  }

  return (
    <Flex
      bg="accent.3"
      justify="space-between"
      align="center"
      className="p-5 border rounded-lg border-accent-3"
      gap={8}
    >
      <Flex gap={8}>
        <SecurityIcon />

        <Stack gap={8} flex={1}>
          <Title className="text-primary-text-body prose-lg/medium">
            Secure {admin ? "Account" : "Your Account"}
          </Title>

          <Text
            className="prose-base/regular text-primary-text-subtle text-wrap"
            maw={600}
          >
            Two-factor authentication adds an extra layer of security to your
            account. To log in, in addition you'll need to provide a 6 digit
            code
          </Text>
        </Stack>
      </Flex>

      <Button
        loading={isPending}
        disabled={isPending}
        miw="fit-content"
        onClick={handleEnable}
      >
        Enable
      </Button>
    </Flex>
  );
}
